/**
 * Cursor pagination.
 *
 * Offset pagination is not offered. Scope is a query predicate (NFR-06), so the
 * row set a caller can see is a function of their claims; an offset into a set
 * that differs per caller and shifts as contracts are added is a footgun with no
 * upside at ~10 contracts a month.
 */
import { z } from 'zod';
/** Applied when `page.limit` is omitted. Server-side, not a Zod `.default()`. */
export const DEFAULT_PAGE_LIMIT = 20;
export const MAX_PAGE_LIMIT = 100;
export const PageRequestSchema = z
    .object({
    limit: z.number().int().min(1).max(MAX_PAGE_LIMIT).optional(),
    /** Opaque. Echo `next_cursor` back verbatim; never construct one. */
    cursor: z.string().min(1).max(512).optional(),
})
    .strict();
export const PageInfoSchema = z.object({
    /** `null` when this is the last page. */
    next_cursor: z.string().min(1).max(512).nullable(),
    /** How many items this page carries. */
    returned_count: z.number().int().min(0),
    /**
     * Total matching items **within the caller's resolved scope**, or `null` when
     * the count was too expensive to compute. Never a corpus-wide total: that would
     * disclose the size of a set the caller cannot read.
     */
    total_in_scope: z.number().int().min(0).nullable(),
});
//# sourceMappingURL=pagination.js.map